import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// IMPORT DOCUMENT MODULE COMPONENTS


import { IvAssessmentFormComponent } from '../iv-assessment-form/iv-assessment-form.component';
import { LearnerProfileFormComponent } from '../learner-profile-list/learner-profile-form/learner-profile-form.component';
import { MainDocumentComponent } from './main-document.component';

const routes: Routes = [
  {
    path: '',
    component: MainDocumentComponent,
    children: [
      {
        path: 'learner-profile',
        component: LearnerProfileFormComponent,
      },
      {
        path: 'document-iv',
        component: IvAssessmentFormComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainDocumentRoutingModule { }
